
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/optout",
      function () {
        return require("private-next-pages/optout/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/optout"])
      });
    }
  